<template>
  <div class="credit-root hidden-md-and-up">
    <div class="credit-top margin-top-30">
        <div class="credit-title">
          <div class="credit-title-text margin-top-20">
            <img src="@/assets/yinghui_logo.png" class="credit-title-top-icon"/>
            <span class="margin-left-10 credit-title-top-text">荧辉数字化服务</span>
          </div>
          <div class="credit-top-play-text-phone margin-top-20">
            <span v-for="(char, index) in displayedText" :key="index" :style="{ color: index < text.length / 2 ? '#2f2f2f' : '#1b57ec' }">{{ char }}</span>
          </div>
        </div>
      <div class="credit-btn margin-top-20 margin-bottom-20" @click="onBtnClick()">
        <span class="credit-btn-text">了解详情</span>
        <img src="@/assets/home/img_home_next.png" class="credit-btn-icon margin-left-10">
      </div>
    </div>

    <div class="credit-content margin-top-15">
        <div class="credit-item">
          <div class="h-start-container">
            <img src="@/assets/home/top/img_home_xingzheng.png" class="credit-item-title-icon"/>
            <span class="credit-item-title-text margin-left-15">行政处罚</span>
          </div>
          <span class="credit-item-text margin-top-20">企业被行政处罚？别忧心！我们的维护服务能迅速处理不良记录影响，还您企业一片清朗信誉天空，助力业务蓬勃发展。</span>
          <span class="credit-item-list margin-top-15">① 警告</span>
          <span class="credit-item-list margin-top-10">② 处以罚金并且公示</span>
          <span class="credit-item-list margin-top-10">③ 没收违法所得</span>
          <span class="credit-item-list margin-top-10">④ 撤销正常营业行为</span>
          <span class="credit-item-list-more margin-top-10" @click="onBtnClick()">更多行政处罚类型</span>
        </div>
        <div class="credit-item">
          <div class="h-start-container">
            <img src="@/assets/home/top/img_home_sifa.png" class="credit-item-title-icon"/>
            <span class="credit-item-title-text margin-left-15">司法案件</span>
          </div>
          <span class="credit-item-text margin-top-20">企业行政处罚维护，争分夺秒！我们以极快速度启动流程，高质量完成维护，让您的企业迅速恢复元气，抢占市场先机。</span>
          <span class="credit-item-list margin-top-15">① 合同纠纷</span>
          <span class="credit-item-list margin-top-10">② 知识产权纠纷</span>
          <span class="credit-item-list margin-top-10">③ 劳动仲裁</span>
          <span class="credit-item-list margin-top-10">④ 环境污染纠纷</span>
          <span class="credit-item-list-more margin-top-10" @click="onBtnClick()">更多司法案件类型</span>
        </div>
        <div class="credit-item">
          <div class="h-start-container">
            <img src="@/assets/home/top/img_home_yichang.png" class="credit-item-title-icon"/>
            <span class="credit-item-title-text margin-left-15">历史记录处理</span>
          </div>
          <span class="credit-item-text margin-top-20">已结案的诉讼记录、已执行完毕的执行案件记录、行政处罚记录、金融信用记录、负面记录，合法快速处理，不留痕迹。</span>
          <span class="credit-item-list margin-top-15">① 诉讼记录</span>
          <span class="credit-item-list margin-top-10">② 历史环保处罚记录</span>
          <span class="credit-item-list margin-top-10">④ 历史税务处罚记录</span>
          <span class="credit-item-list margin-top-10">③ 历史失信被执行人</span>
          <span class="credit-item-list-more margin-top-10" @click="onBtnClick()">更多历史记录类型</span>
        </div>
        <div class="credit-item">
          <div class="h-start-container">
            <img src="@/assets/home/top/img_home_sanfang.png" class="credit-item-title-icon"/>
            <span class="credit-item-title-text margin-left-15">对接各大平台</span>
          </div>
          <span class="credit-item-text margin-top-20">专家团队对接公示系统、各省、市的信用信息平台、三方企业信息查询平台，快速合法合规为您处理企业不良记录信息。</span>
          <span class="credit-item-list margin-top-15">① 信用中国</span>
          <span class="credit-item-list margin-top-10">② 企业信用信息公示系统</span>
          <span class="credit-item-list margin-top-10">③ 各省、市的信用信息平台</span>
          <span class="credit-item-list margin-top-10">④ 企某查、天某查、启某宝等查询平台</span>
          <span class="credit-item-list-more margin-top-10" @click="onBtnClick()">更多对接平台类型</span>
        </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {ref, onMounted, computed} from 'vue';
import {AppConfig} from "@/config";
import {isShowQrCodeDialog} from "@/views/data/CommonData";

const onBtnClick = () => {
  isShowQrCodeDialog.value = true
}

// let text = "VUEVUEVUE";
let text = "企业信用快速维护";
let displayedText = ref("");
let index = 0;

const displayTextOneByOne = () => {
  if (index < text.length) {
    if (displayedText.value.length >= text.length) {
      displayedText.value = ""
    }
    displayedText.value += text.charAt(index);
    index++;
    setTimeout(displayTextOneByOne, 200);
  } else if (displayedText.value.length === text.length) {
    index = 0;
    setTimeout(displayTextOneByOne, 2000);
  }
}

onMounted(() => {
  displayTextOneByOne();
});

const textColor = computed(() => {
  return 'red'; // 最后几个字的颜色为红色
});
</script>

<style scoped>
.credit-root {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.credit-top {
  width: 92%;
  height: 200px;
  background-color: #ffffff;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.credit-title{
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.credit-title-text{
  display: flex;
  justify-content: center;
  align-items: center;
}

.credit-title-top-icon {
  width: 50px;
  height: auto;
}

.credit-title-top-text {
  font-size: 15px;
  color: #666666;
  letter-spacing: 1px;
}

.credit-top-play-text-phone {
  display: flex;
  font-size: 30px;
  letter-spacing: 5px;
  font-weight: bold;
}

.credit-btn {
  width: 220px;
  height: 60px;
  display: flex;
  justify-content: center;
  border-radius: 30px;
  align-items: center;
  background-image: linear-gradient(to right, #1b57ec, #9775fa);
  cursor: pointer;
}

.credit-btn-text {
  font-weight: bold;
  font-size: 18px;
  color: #f2f2f2;
}

.credit-btn-icon {
  width: 30px;
  height: auto;
}
.credit-content{
  width: 92%;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.5), rgba(27, 87, 236, 1));
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 15px 15px 0px;
  border-radius: 10px;
}
.credit-item {
  width: 100%;
  border-radius: 10px;
  background-color: #ffffff;
  box-sizing: border-box;
  border: 1px solid #f1f7ff;
  padding: 25px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  position: relative;
  white-space: pre-wrap;
}

.credit-item-list{
  width: 100%;
  background-image: linear-gradient(to right, #f1f7ff, #f1f7ff);
  height: 35px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding-left: 10px;
  font-size: 13px;
  color: #2a2a2a;
}

.credit-item-list-more{
  width: 100%;
  background-image: linear-gradient(to right, #1b57ec, #f1f7ff);
  height: 35px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding-left: 10px;
  font-size: 13px;
  color: #ffffff;
}

.credit-item-title-icon {
  width: 30px;
  height: auto;
}

.credit-item-title-text {
  font-size: 15px;
  color: #2a2a2a;
  z-index: 2;
  font-weight: bold;
  letter-spacing: 1px;
}

.credit-item-text {
  word-wrap: break-word; /* 当单词太长无法在一行内容纳时，自动将单词拆分成多行 */
  word-break: break-all; /* 允许在单词内换行 */
  font-size: 14px;
  color: #444444;
  z-index: 2;
  line-height: 25px;
  letter-spacing: 1px;
}

.credit-item-img {
  width: 90%;
  max-width: 300px;
  height: auto;
  align-self: center;
  position: absolute;
  bottom: 0;
  z-index: 1;
}
</style>
